import React from 'react';
import './Datasafety.css';
import Header from './Header';
import Footer from './Footer';

const Datasafety = () => {
    return (
        <div>
            <Header />
            <div className="nd-safety-page">
                <div className="nd-safety-container container">
                    <div className="nd-safety-hero">
                        <div className="nd-safety-badge">Security Infrastructure & Protection</div>
                        <h1 className="nd-safety-title">Data Safety and Web Security</h1>
                    </div>

                    <div className="nd-safety-lead-card">
                        <p>
                            At N D Techland Private Limited, we prioritize the safety and security of your data while using our product N D Connect. We implement stringent security measures to ensure that your personal, business, and operational data are protected at all times. Below is a detailed outline of our data safety and web security practices:
                        </p>
                    </div>

                    <div className="nd-safety-cards-stack">
                        {/* Section 1 */}
                        <div className="nd-safety-card">
                            <div className="nd-safety-card-header">
                                <span className="nd-safety-num">01</span>
                                <h5><strong>1. Data Safety</strong></h5>
                            </div>
                            <div className="nd-safety-card-body">
                                <p>We take the utmost care in safeguarding your data to prevent unauthorized access, breaches, and misuse. Our approach includes:</p>

                                <div className="nd-safety-grid">
                                    <div className="nd-safety-grid-box">
                                        <h6><strong>Data Encryption:</strong></h6>
                                        <p>All sensitive information, including login credentials and transaction details, is encrypted using SSL (Secure Socket Layer) technology during transmission to ensure that it remains secure.</p>
                                    </div>
                                    <div className="nd-safety-grid-box">
                                        <h6><strong>Storage Security:</strong></h6>
                                        <p>Data stored on our servers is protected with advanced encryption methods. We use state-of-the-art security solutions to keep your information safe from unauthorized access.</p>
                                    </div>
                                    <div className="nd-safety-grid-box">
                                        <h6><strong>Regular Backups:</strong></h6>
                                        <p>We conduct regular backups of all critical data to ensure that, in the event of system failures, data can be quickly restored without any loss or disruption.</p>
                                    </div>
                                    <div className="nd-safety-grid-box">
                                        <h6><strong>Role-Based Access Control (RBAC):</strong></h6>
                                        <p>Access to your account and data is restricted based on roles and permissions, ensuring that only authorized personnel can access sensitive information.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 2 */}
                        <div className="nd-safety-card">
                            <div className="nd-safety-card-header">
                                <span className="nd-safety-num">02</span>
                                <h5><strong>2. Web Security</strong></h5>
                            </div>
                            <div className="nd-safety-card-body">
                                <p>Our web security protocols are designed to protect your data from cyber threats and attacks while using N D Connect. These include:</p>

                                <div className="nd-safety-grid">
                                    <div className="nd-safety-grid-box">
                                        <h6><strong>Secure Servers:</strong></h6>
                                        <p>Our web services are hosted on secure servers, protected with advanced firewalls, to prevent unauthorized intrusions and cyberattacks.</p>
                                    </div>
                                    <div className="nd-safety-grid-box">
                                        <h6><strong>HTTPS Protocol:</strong></h6>
                                        <p>N D Connect uses the HTTPS protocol for all data transmissions, ensuring a secure and encrypted connection between your browser and our server.</p>
                                    </div>
                                    <div className="nd-safety-grid-box">
                                        <h6><strong>Two-Factor Authentication (2FA):</strong></h6>
                                        <p>We provide an extra layer of security with Two-Factor Authentication, requiring a secondary verification step during login to ensure secure access to your account.</p>
                                    </div>
                                    <div className="nd-safety-grid-box">
                                        <h6><strong>Account Protection:</strong></h6>
                                        <p>Our system automatically flags suspicious login attempts, and we notify users of any unusual activities. This helps in preventing unauthorized access to your account.</p>
                                    </div>
                                    <div className="nd-safety-grid-box">
                                        <h6><strong>Regular Security Audits:</strong></h6>
                                        <p>We conduct regular internal and external audits to identify vulnerabilities and ensure that our security protocols are up to date with the latest industry standards.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 3 */}
                        <div className="nd-safety-card">
                            <div className="nd-safety-card-header">
                                <span className="nd-safety-num">03</span>
                                <h5><strong>3. Compliance with Data Protection Regulations</strong></h5>
                            </div>
                            <div className="nd-safety-card-body">
                                <p>We comply with applicable data protection regulations to ensure that your personal data is processed in accordance with privacy laws and standards. These regulations guide how we collect, store, and use your information. We respect your privacy and ensure that your data is only used for legitimate purposes as outlined in our Privacy Policy.</p>
                            </div>
                        </div>

                        {/* Section 4 */}
                        <div className="nd-safety-card">
                            <div className="nd-safety-card-header">
                                <span className="nd-safety-num">04</span>
                                <h5><strong>4. User Responsibilities</strong></h5>
                            </div>
                            <div className="nd-safety-card-body">
                                <p>While we employ robust security measures, the safety of your account also depends on how you manage your login credentials. We encourage users to:</p>

                                <ul className="nd-safety-checklist">
                                    <li><span className="nd-safety-check-icon">✓</span><span><strong>Use strong passwords and update them regularly.</strong></span></li>
                                    <li><span className="nd-safety-check-icon">✓</span><span><strong>Keep login credentials confidential and not share them with unauthorized individuals.</strong></span></li>
                                    <li><span className="nd-safety-check-icon">✓</span><span><strong>Notify us immediately of any suspicious activity or unauthorized access to your account.</strong></span></li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 5 */}
                        <div className="nd-safety-card">
                            <div className="nd-safety-card-header">
                                <span className="nd-safety-num">05</span>
                                <h5><strong>5. Continuous Monitoring and Improvement</strong></h5>
                            </div>
                            <div className="nd-safety-card-body">
                                <p>We continuously monitor our systems for potential vulnerabilities and threats. We also work to improve our security infrastructure by adopting the latest technologies and practices to ensure that your data remains safe.</p>
                            </div>
                        </div>

                        {/* Contact & Support Card */}
                        <div className="nd-safety-card nd-safety-contact-card">
                            <div className="nd-safety-card-header">
                                <span className="nd-safety-num">📞</span>
                                <h5><strong>Support & Inquiries</strong></h5>
                            </div>
                            <div className="nd-safety-card-body">
                                <p>
                                    For any concerns or questions regarding data safety and web security, please feel free to contact us at <a href="mailto:info@ndtechland.com">info@ndtechland.com</a> or call 0120-4354103. Your security is our top priority.
                                </p>

                                <div className="nd-safety-contact-grid">
                                    <div className="nd-safety-contact-item">
                                        <span className="nd-safety-contact-label">Email</span>
                                        <span className="nd-safety-contact-val"><a href="mailto:info@ndtechland.com">info@ndtechland.com</a></span>
                                    </div>
                                    <div className="nd-safety-contact-item">
                                        <span className="nd-safety-contact-label">Phone Support</span>
                                        <span className="nd-safety-contact-val">0120-4354103</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Datasafety;
